import React from 'react';
import { UserType } from './types';
import { Icons } from '@/icons';
import { formatLocalDate } from '@/utils/FormateLocalDate';

const { PreviewUser, PreviewEmail, PreviewPhone, PreviewDOB } = Icons;
interface Props {
  user: UserType;
}

const CampaignPublisherDetail: React.FC<Props> = ({ user }) => (
    <div className="space-y-8 h-full w-full ">
      <div className="flex items-center border-b py-2 space-x-3">
        <PreviewUser className="w-6 h-6 text-gray-600" />
        <div>
          <h5 className="text-xs text-gray-500 uppercase">Name</h5>
          <p className="mt-1 text-sm text-gray-700">{user.name}</p>
        </div>
      </div>

      <div className="flex items-center border-b py-2 space-x-3">
        <PreviewEmail className="w-6 h-6 text-gray-600" />
        <div>
          <h5 className="text-xs text-gray-500 uppercase">Email</h5>
          <p className="mt-1 text-sm text-gray-700">{user.email}</p>
        </div>
      </div>

      <div className="flex items-center border-b py-2 space-x-3">
        <PreviewPhone className="w-6 h-6 text-gray-600" />
        <div>
          <h5 className="text-xs text-gray-500 uppercase">Phone Number</h5>
          <p className="mt-1 text-sm text-gray-700">{user.phone ? user.phone : "null"}</p>
        </div>
      </div>

      <div className="flex items-center border-b py-2 space-x-3">
        <PreviewDOB className="w-6 h-6 text-gray-600" />
        <div>
          <h5 className="text-xs text-gray-500 uppercase">Date of Birth</h5>
          <p className="mt-1 text-sm text-gray-700">{user.date_of_birth ? formatLocalDate(user.date_of_birth) : "null"}</p>
        </div>
      </div>

  
    </div>
);

export default CampaignPublisherDetail;
